<div class="page-container">
  <div class="header-section">
    <h1>Inspection Overview</h1>
    <button *ngIf="!isAuditor" class="btn-primary" (click)="createInspection()">
      <span class="material-icons">add</span>
      New Inspection
    </button>
  </div>

  <div class="filter-section">
    <div class="search-box">
      <span class="material-icons search-icon">search</span>
      <input
        pInputText
        [(ngModel)]="searchText"
        (input)="onSearchChange()"
        placeholder="Search by order number, type, customer, factory..."
        class="search-input"
      />
      <button
        *ngIf="searchText"
        class="clear-search-btn"
        (click)="clearSearch()"
      >
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="status-quickfilters" role="group" aria-label="Filter by inspection status">
      <button
        *ngFor="let filter of statusQuickFilters"
        type="button"
        class="status-quickfilter-btn"
        [class.status-quickfilter-btn--active]="isStatusFilterActive(filter.value)"
        (click)="setStatusFilter(filter.value)">
        {{ filter.label }}
      </button>
    </div>

    <div class="filter-info">
      <span class="result-count">{{ gridView.total }} Inspections found</span>
    </div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner styleClass="labtech-spinner" ariaLabel="Loading"></p-progressSpinner>
    <p>Loading inspections...</p>
  </div>

  <div class="cards-grid" *ngIf="!loading">
    <div class="card" *ngFor="let inspection of gridView.data" [@cardAnimation]>
      <div
        class="card-header"
        [ngClass]="{
          'card-header--passed': inspection.inspectionStatusId === 3,
          'card-header--failed': inspection.inspectionStatusId === 4
        }"
      >
        <div class="card-icon">
          <span class="material-icons">assignment</span>
        </div>
        <div class="card-title-section">
          <h3 class="card-title">{{ inspection.orderNumber || "N/A" }}</h3>
          <span
            class="inspection-status-badge"
            [ngClass]="statusClass(inspection)"
          >
            <span class="material-icons" *ngIf="isStarted(inspection)">lock</span>
            {{ statusLabel(inspection) }}
          </span>
        </div>
        <div *ngIf="!isAuditor" class="overview-card-actions">
          <button type="button" class="card-icon-btn" (click)="toggleActionMenu(inspection.inspectionId, $event)"
            [attr.aria-expanded]="isActionMenuOpen(inspection.inspectionId)" title="Inspection actions">
            <span class="material-icons">more_vert</span>
          </button>
          <div class="card-action-menu" *ngIf="isActionMenuOpen(inspection.inspectionId)" (click)="$event.stopPropagation()">
            <button type="button" class="menu-action" (click)="closeActionMenu(); editInspection(inspection)">
              <span class="material-icons">{{ isStarted(inspection) ? "visibility" : "edit" }}</span>
              {{ isStarted(inspection) ? "View" : "Edit" }}
            </button>
            <button type="button" class="menu-action" (click)="closeActionMenu(); executeInspection(inspection)">
              <span class="material-icons">play_arrow</span>
              Execute
            </button>
            <button *ngIf="hasReport(inspection)" type="button" class="menu-action"
              (click)="closeActionMenu(); openReport(inspection)">
              <span class="material-icons">description</span>
              Report
            </button>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="info-row">
          <span class="material-icons info-icon">category</span>
          <div class="info-content">
            <span class="info-label">Inspection Type</span>
            <span class="info-value">{{
              inspection.inspectionType || "N/A"
            }}</span>
          </div>
        </div>

        <div class="info-row">
          <span class="material-icons info-icon">person</span>
          <div class="info-content">
            <span class="info-label">Customer</span>
            <span class="info-value">{{ inspection.customer || "N/A" }}</span>
          </div>
        </div>

        <div class="info-row">
          <span class="material-icons info-icon">factory</span>
          <div class="info-content">
            <span class="info-label">Factory</span>
            <span class="info-value">{{ inspection.factory || "N/A" }}</span>
          </div>
        </div>

        <div class="info-row">
          <span class="material-icons info-icon">groups</span>
          <div class="info-content">
            <span class="info-label">Inspectors</span>
            <span class="info-value">{{ inspection.inspectors || "N/A" }}</span>
          </div>
        </div>

        <div class="info-row">
          <span class="material-icons info-icon">calendar_today</span>
          <div class="info-content">
            <span class="info-label">Inspection Date</span>
            <span class="info-value">{{
              inspection.inspectionDate || "N/A"
            }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>

  <app-empty-state
    *ngIf="!loading && gridView.data.length === 0"
    icon="search_off"
    headline="No inspections found"
    [subline]="emptyStateSubline">
  </app-empty-state>

  <div class="pagination-section" *ngIf="!loading && gridView.total > 0">
    <p-paginator [totalRecords]="gridView.total" [rows]="state.take ?? 12" [first]="state.skip ?? 0" [rowsPerPageOptions]="[12, 24, 48]" (onPageChange)="pageChange($event)"></p-paginator>
    <span class="result-count pagination-range">{{ footerRangeLabel }}</span>
  </div>
</div>
